import { PropsWithChildren } from "react";

export type ExpanderButtonProps = {
    state: boolean
}
// For use if the entire area is clickable instead of the button ExpanderLogicButton is used when it has logic
export function ExpanderButton(props: PropsWithChildren<ExpanderButtonProps>) {
    return (
        <button className={`card-mini-button align-content-center fa-solid ${props.state ? "fa-chevron-down" : "fa-chevron-up"}`}></button>
    );
}